import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const DischargeLoanPaymentPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <section className="pt-32 pb-20 bg-background">
        <div className="max-w-6xl mx-auto px-4">
          <div className="mb-8">
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-4">
              Discharge Process Startup Donation
            </h1>
            <p className="text-xl text-muted-foreground">
              Select any cryptocurrency to make your $200 startup donation, and we will begin the discharge process for your mortgage, car loan, or credit card debt.
            </p>
          </div>

          <div className="flex justify-center">
            <div className="relative w-full max-w-[410px] mx-auto px-4 sm:px-0">
              <iframe 
                src="https://nowpayments.io/embeds/payment-widget?iid=4321983878" 
                width="100%" 
                height="696" 
                frameBorder="0" 
                scrolling="no" 
                style={{ overflowY: 'hidden', maxWidth: '410px' }}
                title="Discharge Process Startup Donation"
              >
                Can't load widget
              </iframe>
              {/* Overlay to cover watermark at bottom */}
              <div className="absolute bottom-0 left-4 right-4 sm:left-0 sm:right-0 h-16 bg-white"></div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default DischargeLoanPaymentPage;